<script setup lang="ts">
import { Tabbar, TabbarItem } from 'vant';
import { $t } from '@/locales';
import { useRouter } from 'vue-router';

const router = useRouter();

const onBack = () => {
  router.back();
};
</script>

<template>
  <Tabbar placeholder route safe-area-inset-bottom>
    <TabbarItem class="tabbar-item" @click="onBack">
      {{ $t('common.return') }}
    </TabbarItem>
  </Tabbar>
</template>

<style scoped>
.tabbar-item {
  font-size: 16px;
}
</style>
